import React, { useState, useEffect, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import { FaArrowRight, FaArrowLeft, FaChevronDown } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import { API_BASE } from '../config';
import './HeroSlider.css';

const HeroSlider = () => {
  const [slides, setSlides] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    fetch(`${API_BASE}/slides`)
      .then(res => res.json())
      .then(data => setSlides(data))
      .catch(() => {});
  }, []);

  const onSlideChange = useCallback((swiper) => {
    setActiveIndex(swiper.realIndex);
    setProgress(0);
  }, []);

  const onAutoplayTimeLeft = useCallback((swiper, time, progressVal) => {
    setProgress(1 - progressVal);
  }, []);

  if (slides.length === 0) return null;

  return (
    <section className="hero-slider">
      <Swiper
        modules={[Autoplay, EffectFade, Navigation]}
        effect="fade"
        loop={true}
        speed={1000}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: '.hero-nav-prev',
          nextEl: '.hero-nav-next',
        }}
        onSlideChange={onSlideChange}
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        className="hero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={slide._id || index}>
            <div className="hero-slide">
              <div
                className="hero-bg"
                style={{ backgroundImage: `url(${slide.image})` }}
              ></div>
              <div className="hero-overlay"></div>

              <div className="hero-content">
                <div className="hero-tag">{String(index + 1).padStart(2, '0')}</div>
                <span className="hero-subtitle">{slide.subtitle}</span>
                <h1 className="hero-title">
                  {slide.title}
                  <br />
                  <span className="hero-title-highlight">{slide.titleHighlight}</span>
                </h1>
                <p className="hero-description">{slide.description}</p>
                {slide.buttonText && (
                  <div className="hero-actions">
                    <a href={slide.buttonLink || '#'} className="hero-btn">
                      <span>{slide.buttonText}</span>
                      <FaArrowRight className="hero-btn-icon" />
                    </a>
                    <div className="hero-line"></div>
                  </div>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation */}
      <div className="hero-navigation">
        <button className="hero-nav-prev">
          <FaArrowLeft />
        </button>
        <div className="hero-nav-counter">
          <span className="hero-nav-current">{String(activeIndex + 1).padStart(2, '0')}</span>
          <div className="hero-nav-progress">
            <div className="hero-nav-progress-bar" style={{ height: `${progress * 100}%` }}></div>
          </div>
          <span className="hero-nav-total">{String(slides.length).padStart(2, '0')}</span>
        </div>
        <button className="hero-nav-next">
          <FaArrowRight />
        </button>
      </div>

      {/* Scroll Down */}
      <div className="hero-scroll-down">
        <a href="#content">
          <span className="hero-scroll-text">Aşağı Kaydır</span>
          <FaChevronDown className="hero-scroll-icon" />
        </a>
      </div>
    </section>
  );
};

export default HeroSlider;
